import { concat, join, map, merge, toPairs } from 'ramda'
import { BootstrapData, QueryString, Referral } from '@/types'

const buildReferralData = (
  isAndroid: boolean,
  referral: Referral | Record<string, never>
): Referral =>
  merge(
    {
      sourceId: '',
      id: 'DTAPPDL',
      clickId: isAndroid ? 'MWEBHPANDROID' : 'MWEBHPIOS'
    },
    referral
  )

const baseUrlAndroid = 'https://www.priceline.com/r/app/'
const baseUrlNoAndroid = 'https://offers.priceline.com/lrapp/'

export const getLink = (
  isAndroid: boolean,
  referral: Referral | Record<string, never>,
  clientGUID: string,
  pageId: string
) => {
  const {
    id = '',
    sourceId = '',
    clickId = ''
  } = buildReferralData(isAndroid, referral)
  const queryStringObject: QueryString = {
    channel: 'Display',
    product: 'App',
    theme: 'app_dl_install',
    refid: `${sourceId}${id}`,
    refclickid: clickId,
    PAGEID: pageId,
    ...(clientGUID && {
      subSiteId: clientGUID
    })
  }
  const baseUrl = isAndroid ? baseUrlAndroid : baseUrlNoAndroid

  return concat(
    concat(baseUrl, '?'),
    join('&', map(join('='), toPairs(queryStringObject)))
  )
}

export const getTrafficInfo = (
  query: QueryString,
  referral: Partial<Referral>
) => {
  const {
    id: _ckReferralId = '',
    clickId: cookieRefClickId = '',
    sourceId: _ckRefSourceId = ''
  } = referral
  const cookieRefId = _ckRefSourceId.concat(_ckReferralId)

  const { refid: _qsRefId = '', refclickid: _qsRefClickId = '' } = query
  const queryRefId =
    typeof _qsRefId === 'string' && Object.keys(_qsRefId).length > 0
      ? _qsRefId
      : ''
  const queryRefClickId =
    typeof _qsRefClickId === 'string' && Object.keys(_qsRefClickId).length > 0
      ? _qsRefClickId
      : ''

  const isPaid =
    cookieRefId.indexOf('GOOGLECPC|MSN') > -1 ||
    queryRefId.indexOf('GOOGLECPC|MSN') > -1

  const isBranded =
    cookieRefClickId.indexOf('BRAND') > -1 ||
    queryRefClickId.indexOf('BRAND') > -1

  const excludedRefIds = ['PLHTLCOMBINED', 'PLHBC10161OPQ']
  const isBlackListed =
    cookieRefId.indexOf('CO') === 0 ||
    queryRefId.indexOf('CO') === 0 ||
    excludedRefIds.indexOf(cookieRefId) > -1 ||
    excludedRefIds.indexOf(queryRefId) > -1

  return {
    isPaid,
    isBranded,
    isBlackListed
  }
}

export const getPropsForAppBanner = (data: BootstrapData) => {
  const { referral, webstats, isMobile, isAndroid } = data

  return {
    referral: referral ?? {},
    clientGUID: webstats?.clientGUID ?? '',
    isMobile,
    isAndroid
  }
}
